import { uniqBy } from "lodash-es";
import { Trans } from "react-i18next";
import { defaultTransComponents } from "src/config/i18n";
import { GROUPS } from "src/config/overlayers";
import { Overlayer, LayerManagerContext, ResidentialEmissionMap, ResidentialTotalEmissionMap } from "src/types";

export function filterActive(overlayers: Overlayer[]) {
  return overlayers.filter((overlayer) => overlayer.isActive);
}

export function filterOverlayersByContext(overlayers: Overlayer[], context: LayerManagerContext) {}

export function filterByContext(context: LayerManagerContext) {
  return function (overlayers: Overlayer[]) {
    return overlayers.filter((overlayer) => overlayer.context.includes(context));
  };
}

export function groupsFromOverlayers(overlayers: Overlayer[]) {
  return uniqBy(overlayers, "group.name").map((i) => i.group);
}

export function updateOverlayer(items: Overlayer[], update: Overlayer) {
  return items.map((item) => {
    // keep previous settings, merge with update
    if (item.key === update.key) {
      return update;
    } else return item;
  });
}

export function addOrUpdateInList(items: Overlayer[], update: Overlayer) {
  const keys = items.map((i) => i.key);

  if (keys.indexOf(update.key) === -1) {
    return [...items, update];
  } else {
    return updateOverlayer(items, update);
  }
}

export function paneZIndex(zIndex: number) {
  /**
   * Leaflet by default gruops layers together in panes by type
   * For layer manager layers, we extend this and build on top of a fixed zIndex
   * https://leafletjs.com/examples/map-panes/
   * https://leafletjs.com/reference.html#map-pane
   */

  const BASE_ZINDEX = 400;
  return zIndex + BASE_ZINDEX;
}

export function residentialMapToOverlayer(data: ResidentialEmissionMap): Overlayer {
  const name = (
    <span>
      <Trans i18nKey={data.substance.name} components={defaultTransComponents} />{" "}
      <Trans i18nKey={data.fuel?.translation} components={defaultTransComponents} />{" "}
      <Trans i18nKey={data.dwelling?.translation} components={defaultTransComponents} />{" "}
      <Trans i18nKey={data.appliance?.translation} components={defaultTransComponents} />{" "}
    </span>
  );

  return {
    key: `residential-maps-${data.id}`,
    name,
    unit: "µg/m³",
    layers: data.geoserverLayer,
    isActive: false,
    opacity: 0.8,
    zIndex: 0,
    group: GROUPS.residentialMaps,
    url: "/geoserver/wms",
    context: ["case-edit", "case-results"],
    layerManager: { showFrontLegend: true, showBackLegend: false, showInLayerManager: true },
    legend: { legendType: "wms" },
  };
}

export function residentialTotalMapToOverlayer(data: ResidentialTotalEmissionMap): Overlayer {
  const name = <Trans i18nKey={data.substance.name} components={defaultTransComponents} />;

  return {
    key: `residential-maps-${data.id}`,
    name,
    unit: "µg/m³",
    isActive: false,
    opacity: 0.8,
    zIndex: 0,
    layers: data.geoserverLayer,
    group: GROUPS.residentialMaps,
    url: "/geoserver/wms",
    context: ["case-edit", "case-results"],
    layerManager: { showFrontLegend: true, showBackLegend: false, showInLayerManager: true },
    legend: { legendType: "wms" },
  };
}
